// extracted by mini-css-extract-plugin
export default {"siteHeader":"header_siteHeader__nFyX8","title":"header_title__CMEh6","header":"header_header__RwrsQ","logo":"header_logo__JY-0E"};